<template>
    <div class="slide-container">
        <div class="section-title">精选下载</div>
        <div class="list-wrap">
            <article class="download-card" v-for="item in topList" :key="item.id">
                <div class="left-wrap">
                    <img class="cover" :src="item.pic" alt="" />
                    <div class="info">
                        <div class="title">{{ item.title }}</div>
                        <div class="desc">试玩次数: {{ Number(item.num || 0) }}</div>
                    </div>
                </div>
                <button type="button" class="download-btn" @click="goDownload(item)">下载</button>
            </article>
        </div>
    </div>
</template>

<script>
export default {
    props: ["dataList"],
    computed: {
        topList() {
            const list = Array.isArray(this.dataList) ? this.dataList : []
            return list.slice(0, 8)
        }
    },
    methods: {
        goDownload(item) {
            if (!item || !item.url) return
            const popup = window.open(item.url, '_blank')
            if (!popup) {
                window.location.href = item.url
            }
            this.$http.post('/track_click', {
                target_type: 'app',
                target_id: item.id
            }).catch(() => {
                // 统计失败不阻断下载跳转
            })
        }
    }
};
</script>

<style lang="less" scoped>
.slide-container {
    margin-top: .2rem;
    padding: .2rem;
    border-radius: .9rem;
    border: 1px solid rgba(115, 80, 225, .55);
    box-shadow: var(--a-shadow);
    background: transparent;
}

.section-title {
    color: #ffffff;
    font-size: 1.15rem;
    font-weight: 800;
    padding: .2rem .35rem .65rem;
}

.list-wrap {
    display: grid;
    gap: .7rem;
}

.download-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .6rem;
    padding: .62rem .72rem;
    border-radius: .95rem;
    border: 1px solid rgba(133, 98, 241, .6);
    background: linear-gradient(180deg, rgba(35, 8, 93, .98), rgba(25, 6, 71, .98));
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .08), 0 10px 18px rgba(9, 2, 34, .34);
}

.left-wrap {
    display: flex;
    align-items: center;
    min-width: 0;
}

.cover {
    width: 3.65rem;
    height: 3.65rem;
    border-radius: .75rem;
    object-fit: cover;
    border: 1px solid rgba(195, 175, 248, .35);
}

.info {
    margin-left: .62rem;
    min-width: 0;
}

.title {
    color: #ffffff;
    font-size: 1.08rem;
    font-weight: 700;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.desc {
    margin-top: .2rem;
    color: #9180c2;
    font-size: .86rem;
}

.download-btn {
    border: 1px solid rgba(255, 255, 255, .85);
    background: linear-gradient(180deg, rgba(123, 83, 223, .52), rgba(69, 39, 149, .44));
    color: #fff;
    border-radius: 999px;
    min-width: 5.4rem;
    line-height: 1.84rem;
    font-size: .94rem;
    font-weight: 700;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, .3), 0 6px 10px rgba(13, 5, 42, .28);
}

@media screen and (max-width: 360px) {
    .cover {
        width: 3.2rem;
        height: 3.2rem;
    }
    .download-btn {
        min-width: 4.9rem;
        line-height: 1.62rem;
        font-size: .88rem;
    }
}
</style>